export enum PermissionsTypes {
  GET_PERMISSIONS = '@@permissions/GET_PERMISSIONS',
  GET_PERMISSIONS_SUCCESS = '@@permissions/GET_PERMISSIONS_SUCCESS',
  GET_PERMISSIONS_FAIL = '@@permissions/GET_PERMISSIONS_FAIL',

  GET_PERMISSIONS_DETAIL = '@@permissions/GET_PERMISSIONS_DETAIL',
  GET_PERMISSIONS_DETAIL_SUCCESS = '@@permissions/GET_PERMISSIONS_DETAIL_SUCCESS',
  GET_PERMISSIONS_DETAIL_FAIL = '@@clients/GET_CLIENTS_DETAIL_FAIL',

  ADD_PERMISSIONS = '@@permissions/ADD_PERMISSIONS',
  ADD_PERMISSIONS_SUCCESS = '@@permissions/ADD_PERMISSIONS_SUCCESS',
  ADD_PERMISSIONS_FAIL = '@@permissions/ADD_PERMISSIONS_FAIL',

  DELETE_PERMISSIONS = '@@permissions/DELETE_PERMISSIONS',
  DELETE_PERMISSIONS_SUCCESS = '@@permissions/DELETE_PERMISSIONS_SUCCESS',
  DELETE_PERMISSIONS_FAIL = '@@permissions/DELETE_PERMISSIONS_FAIL',

  UPDATE_PERMISSIONS = '@@permissions/UPDATE_PERMISSIONS',
  UPDATE_PERMISSIONS_SUCCESS = '@@permissions/UPDATE_PERMISSIONS_SUCCESS',
  UPDATE_PERMISSIONS_FAIL = '@@permissions/UPDATE_PERMISSIONS_FAIL',
}
